
/**
 * 정렬 기준 필드명
 */
export type SortByParameterParameter = string;
